// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legible {
  font-family: monospace;
  font-size: 1.5rem;
  letter-spacing: 5px;
}

ol {
  margin-bottom: 0;
  padding-left: 0;
}

ol li {
  padding-bottom: 5px;
}

ol.start {
  counter-reset: mycounter;
}

ol.start li, ol.continue li {
  list-style: none;
}

ol.start li:before, ol.continue li:before {
  content: counter(mycounter) ". ";
  counter-increment: mycounter;
}

/* QR Modal */
::ng-deep .qrcode img {
  cursor: pointer;
}

#qrImageModal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
}
#qrImageModal ::ng-deep .qrcode {
  height: 100%;
  padding: 30px;
}
#qrImageModal ::ng-deep .qrcode img {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}

.qrimgcode ::ng-deep div img {
  width: 150px;
  height: auto;
}
@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.close {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 45px;
  transition: 0.3s;
  color: #b4bdce;
}

.close:hover,
.close:focus {
  cursor: pointer;
  color: #7987a1;
}

#overlay {
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
}

.loading {
  opacity: 0.05;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/enrollment/methods/soft-token/soft-token.component.scss"],"names":[],"mappings":"AAUA;EACE,sBAAA;EACA,iBAAA;EACA,mBAAA;AATF;;AAYA;EACE,gBAAA;EACA,eAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,wBAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,gCAAA;EACA,4BAAA;AATF;;AAYA,aAAA;AAEA;EACE,eAAA;AAVF;;AAaA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAVF;AAYE;EACE,YAAA;EACA,aAAA;AAVJ;AAYI;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAVN;;AAkBM;EACE,YAAA;EACA,YAAA;AAfR;AA+BA;EACE;IACE,mBAAA;EApBF;EAuBA;IACE,mBAAA;EArBF;AACF;AAwBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAnGS;AA6EX;;AAyBA;;EAEE,eAAA;EACA,cAvGS;AAiFX;;AAyBA;EACE,eAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF;AARA,42GAA42G","sourcesContent":["$gray-100: #f4f5f8;\n$gray-200: #e3e7ed;\n$gray-300: #cdd4e0;\n$gray-400: #b4bdce;\n$gray-500: #97a3b9;\n$gray-600: #7987a1;\n$gray-700: #596882;\n$gray-800: #3b4863;\n$gray-900: #1c273c;\n\n.legible {\n  font-family: monospace;\n  font-size: 1.5rem;\n  letter-spacing: 5px;\n}\n\nol {\n  margin-bottom: 0;\n  padding-left: 0;\n}\n\nol li {\n  padding-bottom: 5px;\n}\n\nol.start {\n  counter-reset: mycounter;\n}\n\nol.start li, ol.continue li {\n  list-style: none;\n}\n\nol.start li:before, ol.continue li:before {\n  content: counter(mycounter) \". \";\n  counter-increment: mycounter;\n}\n\n/* QR Modal */\n\n::ng-deep .qrcode img {\n  cursor: pointer;\n}\n\n#qrImageModal {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2001;\n\n  ::ng-deep .qrcode {\n    height: 100%;\n    padding: 30px;\n\n    img {\n      display: block;\n      margin: auto;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\n.qrimgcode {\n  ::ng-deep {\n    div {\n      img {\n        width: 150px;\n        height: auto;\n      }\n    }\n  }\n}\n\n@-webkit-keyframes zoom {\n  from {\n    -webkit-transform: scale(0)\n  }\n\n  to {\n    -webkit-transform: scale(1)\n  }\n}\n\n@keyframes zoom {\n  from {\n    transform: scale(0)\n  }\n\n  to {\n    transform: scale(1)\n  }\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 45px;\n  transition: 0.3s;\n  color: $gray-400;\n}\n\n.close:hover,\n.close:focus {\n  cursor: pointer;\n  color: $gray-600;\n}\n\n#overlay {\n  position: fixed;\n  background: rgb(0,0,0,.7);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2000;\n}\n\n.loading {\n  opacity: 0.05;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
